import * as actions from './actions'
import { groupBy, map } from 'lodash'

export function * getFrames(product) {
  let frames = yield actions.fetchFromAPI(`/products/${product}.json`)

  // TODO: Remove this in the production.
  frames = map(frames.frame_sizes || {}, (frame) => {
    frame.thumbnailUrl = 'https://via.placeholder.com/300'

    return frame
  })

  frames = groupBy(frames, frame => {
    const group = frame.group || {}

    return group.name || 'General'
  })

  frames = map(frames, (frames, name) => ({
    id: 1,
    title: name,
    options: frames
  }))

  return actions.setFrames(frames)
}
